import React, { useEffect, useRef, useState } from "react";
import { RiepilogoPreventivoStickyWidget } from "./RiepilogoPreventivoSticky.style";
import { CommonMFE, Helpers, MFE_NAMES, ReactMFE } from "@tpd-web-common-libs/nodejs-library";
import { LocalStorageLayer, PreventivatoreAutoService } from "@tpd-web-react-libs/nodejs-library/dist/src/providers";
import { CommonFunctions } from "@tpd-web-react-libs/nodejs-library/dist/src/common";
import { TpdLoading } from "@tpd-web-react-libs/nodejs-library/dist/src/components";



type RiepilogoPreventivoStickyProps = {
    __host__: any;
    id: string;
    config: any;
    isEditMode: boolean;
    pType?: string;
};

class Preventivo {
    public show: boolean;
    public veicolo: string;
    public targa: string;
    public mensile: string;
    public nRate: string;
    public annuale: string;
    public annualeScontato: string;
    public idQuotazione: string;
    public tipo: string;
}

const RiepilogoPreventivoSticky = (props: RiepilogoPreventivoStickyProps) => {
    const {
        __host__,
        id: containerID,
        config,
        isEditMode
    } = props;

    const containerRef = useRef<HTMLDivElement>(null);
    const [preventivo, setPreventivo] = useState<Preventivo>(new Preventivo());
    const [showError, setShowError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        window.addEventListener('resize', onWindowResize);
        // Call the function initially to set the correct margin on component mount
        onWindowResize();

        _topLevelGetStorageData("pvshow").then((value) => {
            if (value === "true") {
                compilePrev()
            } else {
                setPreventivo((prevState) => ({
                    ...prevState,
                    show: false,
                }))
            }
        });

        return () => {
            window.removeEventListener('resize', onWindowResize);
        };

    }, []);


    const onWindowResize = () => {
        const preventivatoreElement = containerRef.current?.querySelector<HTMLElement>(".tpd-riepilogo-preventivatore");
        const targetElements = document.querySelectorAll<HTMLElement>(".mbk_footer .bk_018-title, .tpd-row-inner.tpd_footer_text_row");

        if (preventivatoreElement) {
            const result = window.getComputedStyle(preventivatoreElement).height;

            targetElements.forEach((element) => {
                element.style.marginBottom = result;
            });
        }
    };
    /** Clean storage data */
    const cleanData = async () => {
        await Helpers.SessionHelper.deleteData("preventivo_precedente_auto");
    }

    /**
   * Recupera ad alto livello le informazioni dallo storage e gestisce anche il passaggio tra architetture
   * @param id
   * @private
   */
    const _topLevelGetStorageData = async (id: string): Promise<any> => {
        let value = undefined;

        try {
            value = await Helpers.SessionHelper.getData(id);
        } catch (e) {
            console.error(
                "Non é stato possibile recuperare i dati dalla sessione",
                String(e)
            );
        }

        if (Helpers.EnvironmentHelper.isClientSide()) {
            const localStorageData = localStorage.getItem(id);
            if (localStorageData && (!value || value !== localStorageData)) {
                value = localStorageData;
            }
        }

        return value;
    }

    const compilePrev = async () => {

        const compiledPreventivo: Preventivo = new Preventivo();
        const preventivoPrecedenteAuto = await _topLevelGetStorageData(
            "preventivo_precedente_auto"
        );
        let pp;
        try {
            pp = JSON.parse(preventivoPrecedenteAuto);
        } catch (err) {
            console.log("No value found for key preventivo_precedente_auto", err);
        }
        compiledPreventivo.tipo = "auto";
        const preventivoPrecedenteMoto = await _topLevelGetStorageData(
            "preventivo_precedente_moto"
        );
        let ppMoto;
        try {
            ppMoto = JSON.parse(preventivoPrecedenteMoto);
        } catch (err) {
            console.log("No value found for key preventivo_precedente_moto", err);
        }

        if (
            pp == null ||
            pp == undefined ||
            (pp != null &&
                pp != undefined &&
                ppMoto != null &&
                ppMoto != undefined &&
                pp.timeStampQuotazione < ppMoto.timeStampQuotazione)
        ) {
            pp = ppMoto;
            compiledPreventivo.tipo = "moto";
        }
        if (pp != null) {
            compiledPreventivo.show = true;
            compiledPreventivo.veicolo = pp.veicolo;
            compiledPreventivo.targa = pp.targa.replace(/\s/g, "");
            compiledPreventivo.mensile = pp.mensile;
            compiledPreventivo.nRate = pp.nRate;
            compiledPreventivo.annuale = pp.annuale;
            compiledPreventivo.annualeScontato = pp.annualeScontato;
            compiledPreventivo.idQuotazione = pp.idQuotazione;
        } else {
            compiledPreventivo.show = false;
        }

        setPreventivo(compiledPreventivo);
    }

    const close = async () => {
        setPreventivo((prevState) => ({
            ...prevState,
            show: false,
        }))

        await Helpers.SessionHelper.setData("pvshow", "false");

        const openmaskElement = document.getElementById("openmask");

        if (openmaskElement) {
            const clickEvent = new Event("click", {
                bubbles: true,
                cancelable: true,
            });
            openmaskElement.dispatchEvent(clickEvent);
        }
        // eventualmente rimuovere i dati dallo storage.
        cleanData();
    }

    /**
   * Apre l'informativa privacy del preventivatore sticky
   * @param tipoInformativa Tipo di informativa da aprire
   */
    const apriInformativaPrivacy = (tipoInformativa: "auto" | "moto") => {
        if (Helpers.EnvironmentHelper.isClientSide()) {
            const trigger = document.getElementById("openInformativaPrivacy");
            if (trigger) {
                Helpers.SessionHelper.setData(
                    "InformativaPrivacyRiepilogoSticky",
                    tipoInformativa
                ).then(() => {
                    const clickEvent = new Event("click", {
                        bubbles: true,
                        cancelable: true,
                    });
                    trigger.dispatchEvent(clickEvent);
                });
            }
        }
    }

    const recupera = () => {
        setShowError(false);
        setIsLoading(true);
        const userCtx = new LocalStorageLayer().getData1()
            .then((res) => {
                if (res != -1) {
                    new PreventivatoreAutoService()
                        .stampaPreventivo(preventivo.idQuotazione)
                        .then((response) => {
                            CommonFunctions.downloadPDF(
                                { body: response } as any,
                                preventivo.idQuotazione
                            );
                            setIsLoading(false)
                        })
                        .catch((err) => {
                            setShowError(true)
                            setIsLoading(false)
                        });
                } else {
                    /*Not logged*/
                    Helpers.RouterHelper.goTo(
                        Helpers.RouterHelper.normalizeHref(
                            config["Recupera Preventivo"].value.linkElement
                                .destination.value
                        ),
                        { openNewTab: false }
                    );
                }
            })
            .catch((e) => {
                console.log(e);
                /*Not logged or error*/
                Helpers.RouterHelper.goTo(
                    Helpers.RouterHelper.normalizeHref(
                        config["Recupera Preventivo"].value.linkElement
                            .destination.value
                    ),
                    { openNewTab: false }
                );
            });
    }

    const formatNumber = (value: string): string => {
        const numberValue = parseFloat(value);
        if (isNaN(numberValue)) {
            return value; // Return the original string if it cannot be parsed
        }
        // Format number with 1.2-2, meaning minimum 1 digit before the decimal point,
        // and 2 decimal places
        return numberValue.toLocaleString('it-IT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const replaceString = (value: string): string => {
        // Example replacement: replace commas with spaces
        return value?.replace(/,/g, ',');
    };

    const formatMensileAndReplacedValue = replaceString(formatNumber(preventivo.mensile));

    const formatAnnualeScontatoAndReplacedValue = replaceString(formatNumber(preventivo.annualeScontato));


    return (
        <RiepilogoPreventivoStickyWidget className="widget-global-style">
            {isEditMode &&
                <div>
                    <ReactMFE.Remote
                        id={CommonMFE.generateID(
                            containerID,
                            `${MFE_NAMES.tpdRiepilogoPreventivoSticky}-Cta`
                        )}
                        __deps__={React}
                        __host__={__host__}
                        __mfeName__={MFE_NAMES.tpdCta}
                        isEditMode={isEditMode}
                        {...config["Recupera Preventivo"]}
                    />
                </div>
            }
            {preventivo.show &&
                <div className={`tpd-riepilogo-preventivatore ${isLoading ? "is_loading" : ""}`}>
                    {isLoading ? (
                        <TpdLoading isLoading={true} customCirleStyle={{ margin: "30px auto", width: "100px", height: "100px" }}></TpdLoading>
                    ) : (
                        <>
                            <div className="row hidden-xs">
                                <div id="section-1" className="col-md-6 col-md-offset-1 col-lg-5 col-lg-offset-2">
                                    <div className="tpd_whiteLine"></div>
                                    <div
                                        className={`tpd_icon ${preventivo.tipo === 'auto' ? "icon-Mobilita" : ""} ${preventivo.tipo === 'moto' ? "icon-Moto" : ""}`}></div>
                                    <div className="tpd_txtWrapper">
                                        <div className="tpd_txt">Veicolo:</div>
                                        <div className="tpd_txtVeicolo">
                                            <b>{preventivo.veicolo}</b><br/>
                                        </div>

                                        <div className="tpd_txt">Targa:</div>
                                        <div className="tpd_txtTarga">
                                            <b>{preventivo.targa}</b>
                                        </div>
                                    </div>
                                </div>
                                <div id="section-2" className="col-md-4 col-lg-4 tpd_section2">
                                    {
                                        preventivo.nRate == '12' && "Mensile:" ||
                                        preventivo.nRate == '2' && "Semestrale:" ||
                                        preventivo.nRate == '1' && "Annuale:"
                                    }
                                    <div className="tpd_txtBig">
                                        {formatMensileAndReplacedValue} &euro;
                                    </div>
                                </div>
                                <div className="col-md-3 col-lg-2">
                                    {
                                        preventivo.nRate != '1' &&
                                        (
                                          <>
                                            <div className="tpd_whiteLine"></div>
                                            <div className="tpd_txtO">OPPURE</div>
                                          </>
                                        )
                                    }
                                </div>

                                <div id="section-3" className="col-md-5 col-lg-5">
                                    {
                                        preventivo.nRate != '1' &&
                                          (
                                            <>
                                                <div className="tpd_text">Annuale</div>
                                                <div>
                                                    <div className="tpd_txtMedium">
                                                        {formatAnnualeScontatoAndReplacedValue} &euro; &nbsp;
                                                    </div>
                                                    <div className="tpd_premioScontato">Premio annuale</div>
                                                </div>
                                            </>
                                          )
                                    }
                                </div>

                                <div className="col-md-3 col-lg-4 text-center">
                                    <div>
                                        <a
                                          onClick={() => apriInformativaPrivacy(preventivo.tipo === 'auto' ? 'auto' : 'moto')}
                                          className="btn tpd_privacy">Informativa
                                            privacy</a>
                                    </div>

                                    {/*{preventivo.tipo === 'auto' && (
                                        <div>
                                            <a onClick={() => apriInformativaPrivacy('auto')} className="btn tpd_privacy">Informativa
                                                privacy</a>
                                        </div>
                                    )}
                                    {preventivo.tipo === 'moto' && (
                                        <div>
                                            <a onClick={() => apriInformativaPrivacy('moto')} className="btn tpd_privacy">Informativa
                                                privacy</a>
                                        </div>
                                    )}*/}

                                    <div className="tpd_btnWrap">
                                        <button className="tpd_btn" type="button" onClick={() => recupera()}>
                                            Recupera preventivo
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="hidden-md hidden-lg text-center tpd_mobile_prev_container">
                                <div className="tpd_mobile_txt">
                                    Veicolo : <strong>{preventivo.veicolo}</strong>
                                </div>
                                <div className="tpd_mobile_txt">
                                    Targa : <strong>{preventivo.targa}</strong>
                                </div>
                                <button type="button" className="tpd_btn" onClick={() => recupera()}>
                                    Recupera preventivo
                                </button>
                            </div>
                        </>
                    )}

                    <div className="tpd_close" onClick={() => close()}>
                        <span className="icon-Chiudi tpd_iconClose"></span>
                    </div>
                </div>
            }
        </RiepilogoPreventivoStickyWidget>
    );
};

export default RiepilogoPreventivoSticky;
